if (!customElements.get("product-wrapper")) {
  customElements.define(
    "product-wrapper",
    class ProductWrapper extends window.Component {
      constructor() {
        super();
        this.quantity = this.querySelector('input[name="quantity"]');
        this.variantSelectedID = this.querySelector('input[name="id"]');
        this.initQuantity();
        this.addSubscribeContext();
      }

      initQuantity() {
        if (this.quantity && !this.quantity.value) {
          this.quantity.value = "1";
        }
      }

      addSubscribeContext() {
        this.subscribeContext((state, previousState) => {
          if (state.variantSelected?.id !== previousState.variantSelected?.id) {
            if (this.variantSelectedID && state.variantSelected?.id) {
              this.variantSelectedID.value =
                state.variantSelected.id.toString();
            }
            this.updateSKU(state.variantSelected?.sku);
            if (this.quantity)
              this.quantity.value = state.quantity?.toString() ?? "1";
          }
          if (state.quantity != previousState.quantity) {
            if (this.quantity)
              this.quantity.value = state.quantity?.toString() ?? "1";
          }
        });
      }

      updateSKU(newSKU) {
        const skuElement = this.querySelector(".selected-variant-sku");
        if (skuElement && newSKU) {
          skuElement.innerHTML = `Item no. ${newSKU ? newSKU.slice(0,9) : ""}`;
        }
      }
    }
  );
}
